/* global swal:false */
(function () {
  "use strict";

  angular
    .module("admin.users.details.user_lock_logs", [
      "admin.users.details.user_lock_logs.service",
    ])
    .controller("UserLockLogsCtrl", UserLockLogsCtrl);

  /** @ngInject */
  function UserLockLogsCtrl($stateParams, UserLockLogsService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;

    UserLockLogsService.list(vm.userId).then(function (result) {
      for (var i = 0; i < result.results.length; i++) {
        result.results[i]["ts-m"] = new Date(result.results[i]["ts-m"] / 1000);
        result.results[i]["ts"] = new Date(result.results[i]["ts"] / 1000);

        switch (result.results[i].reason) {
          case 1:
            result.results[i].reason = "ChargeBack";
            break;
          case 2:
            result.results[i].reason = "Wash Trade";
            break;
          case 3:
            result.results[i].reason = "Fraud";
            break;
          default:
            result.results[i].reason = "Unspecified";
            break;
        }
      }
      vm.items = result.results;
    });
  }
})();
